import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/employees`;

export const employeeService = {
    getAll,
    getSuggestion,
    search,
    getById,
    create,
    update,
    delete: _delete,
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function search(params) {
    return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion() {
    return fetchWrapper.get(`${baseUrl}/suggestion`);
}

function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}
